<template>
    <b-modal :title="this.$route.name" no-close-on-backdrop hide-footer size="xl" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="addInvoice">
            <div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label ">গ্রাহকের আইডি <span style="color:red">*</span></label>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <select v-validate="'required'"  name="Customer" @change="previousBill()" v-model="newInvoice.customer_id"  class="form-control" >
                                <option value="" >গ্রাহকের আইডি</option>
                                <option   :value="contact.id"  v-for="(contact,index) in allContacts" :key="index">{{contact.account_number}}</option>
                            </select>
                        </div>
                        <p  v-show="errors.has('Customer')" style="color:red">* {{ errors.first('Customer') }}</p>
                        
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label ">হোল্ডিং নং</label>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <select  name="Customer" v-model="newInvoice.holding_no"  class="form-control" >
                                <option value="" >হোল্ডিং নং</option>
                                <option v-for="(holding,index) in holdings" :key="index" :value="holding.id">{{holding.en_name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label ">রাস্তা বা এলাকার নাম</label>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <select  name="Customer" v-model="newInvoice.geo_road_area_id"  class="form-control" >
                                <option value="" >রাস্তা বা এলাকার নাম</option>
                                <option v-for="(roadArea,index) in roadAddresses" :value="roadArea.id" :key="index">{{ roadArea.bn_name}}</option>
                            </select>
                        </div>
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label">গ্রাহকের ঠিকানা</label>
                    <div class="col-sm-4">
                        <input name="address"   v-model="newInvoice.address" class="form-control"  >
                        <p  v-show="errors.has('address')" style="color:red">* {{ errors.first('address') }}</p>
                    </div>
                </div>
                <div class="form-group row">
                    
                    <label for="inputPassword3" class="col-sm-2 col-form-label">মোবাইল</label>
                    <div class="col-sm-4">
                        <input name="phone"   v-model="newInvoice.phone" class="form-control"  >
                        <p  v-show="errors.has('phone')" style="color:red">* {{ errors.first('phone') }}</p>
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label ">গ্রাহকের ধরণ</label>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <select  name="Customer" v-model="newInvoice.customer_type"  class="form-control" >
                                <option value="" >গ্রাহকের ধরণ</option>
                                <option v-for="(ct,index) in custmerLists" :key="index" :value="ct.id">{{ct.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">ডায়া টাইপ </label>
                    <div class="col-sm-4">
                        <select v-model="item_type"  @change="monthlyBill()" class="form-control" >
                            <option value="">ডায়া টাইপ</option>
                            <option :value="project" v-for="(project,index) in projects" :key="index">{{project.name}}</option>
                        </select>
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label">মাসিক বিল</label>
                    <div class="col-sm-4">
                        <input v-model="newInvoice.monthly_price" disabled class="form-control" >
                    </div>
                </div>

                <!-- <input type="hidden" name="account"   v-model="newInvoice.account_id" class="form-control" value="1" > -->
                <!-- <input type="hidden" name="mode"   v-model="newInvoice.mode" class="form-control" value="1" > -->

                <!-- <div  class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">Total Amount</label>
                    <div class="col-sm-4">
                        

                        <input name="Total" @keyup="perinstallment" v-validate="'required'" v-model="newInvoice.total" class="form-control"  >
                        <p  v-show="errors.has('Total')" style="color:red">* {{ errors.first('Total') }}</p>
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label">Purpose Type</label>
                    <div class="col-sm-4">
                        
                    </div>
                </div> -->
                
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">স্টেটাস</th>
                            <th scope="col">মাস</th>
                            <th scope="col">SL</th>
                            <th scope="col">টাকা</th>
                            <th scope="col">বকেয়া চার্জ </th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(bill,index) in this.previous_bill_list" :key="index">
                            <td>
                                <b-form-checkbox 
										v-model="newInvoice.previous_bill" :value="bill">
								</b-form-checkbox>
                                <!-- <a href="#" @click="billAdd(index,0)" v-if="checkBill(bill.id)">
                                    a
                                </a>
                                <a href="#" @click="billAdd(index,1)" v-else>
                                    b
                                </a> -->
                                
                            </td>
                            <td>
                                {{bill.date}}
                            </td>
                            <td>
                                {{bill.invoice_number}}
                            </td>
                            <td>
                                {{bill.total}}
                            </td>
                            <td>
                                {{bill.due_charge}}
                            </td>
                        </tr>
                        <!-- <tr>
                            <td>
                               
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                Total
                            </td>
                            <td>
                                <input type="text" name="total"  disabled  v-model="total" class="form-control" >
                            </td>
                        </tr> -->
                    </tbody>
                    <tbody>
                        <tr>
                            <td>
                               
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                            <td>
                                Total
                            </td>
                            <td>
                                <input type="text" name="total"  disabled  v-model="total" class="form-control" >
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">সুপারিশ </label>
                    <div class="col-sm-4">
                        <input name="personal_note" v-model="newInvoice.personal_note" type="tex" class="form-control" id="inputPassword3" placeholder="সুপারিশ">
                        <p  v-show="errors.has('personal_note')" style="color:red">* {{ errors.first('personal_note') }}</p>
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label">তারিখ <span style="color:red">*</span></label>
                    <div class="col-sm-4">
                        <input  v-validate="'required'"  v-model="newInvoice.date" type="date" class="form-control" id="inputPassword3" placeholder="Date">
                        <p  v-show="errors.has('date')" style="color:red">* {{ errors.first('date') }}</p>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                <input v-if="!addLoader" type="submit" value="Submit" class="btn btn-primary pull-right"/>
                <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
                <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)
import axios from 'axios'
import {ALL_PURPOSE,ALL_ACCOUNT_TYPE2,ALL_CONTACT,ADD_INVOICE} from "../../../store/action.type"
import { mapState,mapGetters } from "vuex"
import { VueEditor } from 'vue2-editor'
export default {
    props:['invoice_type'],
    data(){
        return{
            customer_type:'',
            // invoice_type:1,
            item_type:[],
            clients:[],
            agents:[],
            projects:[],
            largeModal:false,
            addLoader:false,
            previous_bill_list:[],
            // errors:[],
            newInvoiceType:{
                date:'',
                account_id:1,
                agent_id:'',
                customer_id:'',
                visa_id:'',
                invoice_number:'',
                monthly_price:'',
                geo_road_area_id:'',
                holding_no:'',
                customer_type:'',
                item_id:'',
                due_date:'',
                agent_id:'',
                commission_type:'',
                commission_amount:'',
                shipping_charge:'',
                adjustment:0,
                total:'',
                mode:1,
                down_payment:0,
                total_installment:1,
                per_installment_amount:0,
                installment_type:'',
                personal_note:'',
                customer_note:'',
                invoice_type:this.invoice_type,
                previous_bill:[],
                invoice_items:[{
                    project_id:'',
                    quantity:1,
                    rate:0,
                    discount:0,
                    tax:0,
                    amount:0,
                    purpose_id:''
                }],
            },
            newInvoice:{
                date:'',
                account_id:1,
                agent_id:'',
                customer_id:'',
                visa_id:'',
                invoice_number:'',
                monthly_price:'',
                geo_road_area_id:'',
                holding_no:'',
                customer_type:'',
                item_id:'',
                due_date:'',
                agent_id:'',
                commission_type:'',
                commission_amount:'',
                shipping_charge:'',
                adjustment:0,
                total:'',
                mode:1,
                down_payment:0,
                total_installment:1,
                per_installment_amount:0,
                installment_type:'',
                personal_note:'',
                customer_note:'',
                invoice_type:this.invoice_type,
                previous_bill:[],
                invoice_items:[{
                    project_id:'',
                    quantity:1,
                    rate:0,
                    discount:0,
                    tax:0,
                    amount:0,
                    purpose_id:''
                }],
            },
            customerVisaLoading:false,
        }
    },
    
    methods:{
        perinstallment(){
            this.newInvoice.per_installment_amount = ((this.newInvoice.total-this.newInvoice.down_payment)/this.newInvoice.total_installment)
            // alert("ok")
        },
        dueCalculation(amount){
            return amount;
        },
        customerVisa(id){
            this.customerVisaLoading=true;
            this.$store.dispatch('CUSTOMER_VISA',id)
            .then(response=>{
               this.customerVisaLoading=false; 
            })
            .catch(error=>{
               this.customerVisaLoading=false;       
            });
        },
        getRoadHoldings(id){
            this.$store.dispatch('HOLDING_LIST')
            this.$store.dispatch('ROAD_ADDRESS_LIST')
        },
        proRate(index_item){
            var self = this
            this.newInvoice.invoice_items.forEach(function(element,index){
                if(index_item == index){
                    self.projects.forEach(project=>{
                        if(project.id == element.project_id){
                            element.rate = project.sales_price
                        }
                    })
                    
                }
            })
        },
        addInvPro(){
            this.newInvoice.invoice_items.push({
                    project_id:'',
                    quantity:1,
                    rate:0,
                    discount:0,
                    tax:0,
                    amount:0,
                    purpose_id:''
                })
        },
        customerTypeList(){
            this.$store.dispatch('CUSTOMER_TYPE_LIST')
        },
        removeInvPro(index){
            this.newInvoice.invoice_items.splice(index,1)
        },
        // billAdd(index,status){
        //     alert('ss');
        //     if(status==1){
        //         this.newInvoice.previous_bill.push(this.previous_bill_list[index]);
        //     }else{
        //         this.newInvoice.previous_bill.splice(index,1);
        //     }
        //     // this.monthlyBill();
        // },
        openModal(){
            this.largeModal = true
            this.newInvoice = this.newInvoiceType;
        },
        addInvoice(){
            
            this.newInvoice.invoice_type = this.invoice_type;
            this.$validator.validateAll().then( result =>{
                if(result){
                    var data = this.newInvoice
                    this.addLoader = true
                    this.$store.dispatch('ADD_INVOICE',data)
                    .then(response=>{
                        this.addLoader = false;
                        this.largeModal = false
                        this.$iziToast.success({position:'topRight',title:'Ok',message:"Invoice Added Successsfully"})
                    })
                    .catch(error=>{
                        this.addLoader = false; 
                        this.$iziToast.error({position:'topRight',title:'Error',message:"Something Wrong !!"})       
                    });
                }
                
            })
            
        },
        close(){
            this.largeModal = false
        },
        checkBill(id){
            var status = false;
            this.newInvoice.previous_bill.forEach(function (bill){
                if(bill.id==id){
                    status==true;
                }
            });
            return true;
        },
        monthlyBill(){
            if(this.item_type!=undefined){
                this.newInvoice.monthly_price = this.item_type.sales_price;
                this.item_id = this.item_type.id;
            }else{
                this.newInvoice.monthly_price = 0;
            }
        },
        customerType(){
            this.contactClients();
        },
        contactClients(){
            return new Promise((resolve, reject) => {
                var type = this.customer_type;
                axios.get("api/specific/contacts/"+type)
                .then(response => {
                    this.clients = response.data
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        contactAgents(){
            return new Promise((resolve, reject) => {
                var type = 2
                axios.get("api/specific/contacts/"+type)
                .then(response => {
                    this.agents = response.data
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        allProjects(){
            return new Promise((resolve, reject) => {
                axios.get("api/project-all")
                .then(response => {
                    this.projects = response.data
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        previousBill(){
            return new Promise((resolve, reject) => {
                axios.get("api/previous-bill/"+this.newInvoice.customer_id+'/'+this.invoice_type)
                .then(response => {
                    this.newInvoice.previous_bill = response.data;
                    this.previous_bill_list = Object.assign({},response.data);
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        necessaryThings(){
            this.contactAgents()
            this.allProjects()
        }
    },
    mounted(){
        this.necessaryThings()
        this.customerTypeList();
        this.getRoadHoldings();
    },
    computed:{
        ...mapGetters(["getAccountType","allContacts","customervisas","custmerLists","holdings","roadAddresses"]),
        total(){
            var total_bill = 0;
            this.newInvoice.previous_bill.forEach(function (bill){
                total_bill = total_bill+bill.total+bill.due_charge;
            });
            total_bill = total_bill+this.newInvoice.monthly_price;
            this.newInvoice.total = total_bill;

            return total_bill;
        },
        subtotal(){
            var subtotal = 0
            this.newInvoice.invoice_items.forEach(element=>{
                subtotal = subtotal + element.amount 
            })
            return subtotal
        }
        
    },
    components:{
        VueEditor,
    }
}
</script>

<style>
#preview {
        height: 120px;
        width: 70%;
    }
    #preview img{
        height: 100%;
        width: 100%;
    }
</style>
